import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "destination"]

  swap() {
    const sourceValue = this.sourceTarget.value
    const destinationValue = this.destinationTarget.value

    this.sourceTarget.value = destinationValue
    this.destinationTarget.value = sourceValue
  }
}
